
import React from 'react';

// Componente AuthorityBar
const indicators = [
  {
    icon: 'fa-user-md',
    title: 'Liderazgo Clínico',
    desc: 'Diseñado por oncólogos para oncólogos, entendiendo el flujo real.'
  },
  {
    icon: 'fa-vials',
    title: 'Seguridad Farmacéutica',
    desc: 'Validación de mezclas y diluciones críticas.'
  },
  {
    icon: 'fa-hospital-user',
    title: 'Realidad Operativa',
    desc: 'Optimizado junto a personal de enfermería oncológica.'
  },
  {
    icon: 'fa-globe',
    title: 'Estándar Global',
    desc: 'Nativo HL7 FHIR + mCODE® Implementation Guide.'
  }
];

const AuthorityBar: React.FC = () => {
  return (
    <section className="bg-white py-14 border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {indicators.map((item, idx) => (
            <div key={idx} className="flex items-start gap-5">
              <div className="bg-gray-50 p-4 rounded-2xl flex-shrink-0 text-[#0061A0]">
                <i className={`fas ${item.icon} text-2xl`}></i>
              </div>
              <div>
                <h3 className="font-[900] text-sm text-dark uppercase tracking-wide">{item.title}</h3>
                <p className="text-xs text-gray-500 mt-1.5 leading-relaxed font-medium">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AuthorityBar;
